import store from 'src/store';
import {
  setUserType,
  setProps,
} from 'src/actions/ads';
import Utils from 'src/utils/Utils';
import NavExperienceTask from 'src/requests/tasks/user/v1/NavExperienceTask.js'
import RequestManager from 'src/requests/RequestManager';
import { setNodes } from 'src/actions/navbar';
import ExperienceHourRefresh from 'src/AAF/Ads/AdsTimer';
import logger from 'src/utils/logger/logger';

// Main utils
const getAdvertisingConfig = () =>{
    const ads=Utils.getRegionaliazedMetadata('cv_advertising_config', '{"default": { "enable": false}}');
    return ads;
}

const isAdsEnable = () => {
    const meta = getAdvertisingConfig();
    const isAdsEnabled = meta && meta.enable ? meta.enable : false;
    logger.debug(":::/isAdsEnable", meta.enable, meta.skip_offset);
    return isAdsEnabled && isTVPlatformSupported().support;
}


const getUserType = () => {
    const userType = store.getState().ads.userType;
    logger.debug(":::/checkUserType", userType);
    return userType;
};

const getSkipOffSet = () => {
    const meta = getAdvertisingConfig();
    const skip_offset = meta && meta.skip_offset? meta.skip_offset : 5;
    logger.debug(':::/skip_offset', skip_offset);
    return skip_offset;
};

const getexperience_hour_refresh = () => {
    const meta = getAdvertisingConfig();
    const experience_hour_refresh = meta && meta.experience_hour_refresh? meta.experience_hour_refresh : 0;
    logger.debug(':::/experience_hour_refresh', experience_hour_refresh);
    return experience_hour_refresh;
}

const loadUserType = async (redirectToHome) => {
    let result;
    let nav= getUserType();
    try {
        const task = new NavExperienceTask();
        result = await RequestManager.addRequest(task);
        if(result && result.data && result.data.nav_type){
            store.dispatch(setUserType(result.data.nav_type));
        }
        if (result && result.data && result.data.nodes){
            store.dispatch(setNodes(result.data.nodes));
        }
        ExperienceHourRefresh.setTimeoutExperience(nav, redirectToHome);
    } catch (error) {
        logger.error('Error calling UserAdsTask', error);
    }
}

const recibeProps=(history)=>{
    store.dispatch(setProps(history));
}

const getProps = () => {
    const props = store.getState().ads.props;
    logger.debug(":::/props", props);
    return props;
}

const AdsUtils = {
    isAdsEnable,
    getUserType,
    getSkipOffSet,
    getexperience_hour_refresh,
    loadUserType,
    recibeProps,
    getProps
};

export { AdsUtils };



// WEBPACK FOOTER //
// ./src/AAF/Ads/Utils.js